
import Vue from 'vue'
import { mapState } from 'vuex'

interface Methods {
  voltarParaMarcacao(): void;
}

export default Vue.extend<
any,
Methods,
any
>({
  name: 'ConfirmacaoDePedido',

  computed: {
    ...mapState(['solicitacao'])
  },
  methods: {
    voltarParaMarcacao () {
      this.$router.push({ name: 'marcacao' })
    }
  }
})
